import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import './plus-minus.scss'

const PLUS = '+'
const MINUS = '-'


class PlusMinus extends PureComponent {
  onButtonClick = (e, sign) => {
    e.stopPropagation()
    const { minValue, maxValue, initialValue, name, value } = this.props
    let newValue = !value ? initialValue : value
    newValue = parseInt(newValue, 10) + (sign === PLUS ? 1 : -1)

    if (newValue >= minValue && newValue <= maxValue) {
      const { onChange } = this.props
      return onChange(newValue, name)
    }
    return null
  }

  onPlusClick = e => this.onButtonClick(e, PLUS)

  onMinusClick = e => this.onButtonClick(e, MINUS)

  render() {
    const { value, initialValue } = this.props

    return (
      <div className="plus-minus-control">
        <button className="plus-minus__minus" type="button" onClick={this.onMinusClick}>
          {MINUS}
        </button>
        <div className="plus-minus__value">
          {value === '' ? initialValue : value}
        </div>
        <button className="plus-minus__plus" type="button" onClick={this.onPlusClick}>
          {PLUS}
        </button>
      </div>
    )
  }
}


PlusMinus.defaultProps = {
  minValue: 0,
  maxValue: 99,
}

PlusMinus.propTypes = {
  value: PropTypes.number.isRequired,
  initialValue: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  minValue: PropTypes.number,
  maxValue: PropTypes.number,
}

export default PlusMinus
